module.exports = __webpack_public_path__ + "images/lab/editor-dfe22b1916fef9d2b8145c32786237d6.jpg";